import Vue from 'vue';
import router from './router.js';
import user from './user.js';
import uaService from './ua.js';
import { Toast } from 'mint-ui';
import { Indicator } from 'mint-ui';

import {
  Message,
  Loading
} from 'element-ui';
var loadingInstance = null;
// 界面-服务
export default {
  /**
   * 验证
   *
   * @param value 值
   * @param message 提示文字
   */
  verify(value, message) {
    if (value == '' || value == 0 || value == undefined || value == null) {
      this.alert(message);
      return true;
    }
    return false;
  },

  /**
   * 验证多个
   *
   * @param values 多个值
   * @param messages 多个提示文字
   */
  verifys(values = [], messages = []) {
    if (values.length != messages.length) {
      this.alert('数据不匹配');
      return true;
    }
    for (var i = 0; i < values.length; i++) {
      if (this.verify(values[i], messages[i])) return true;
    }
    return false;
  },

  /**
   * 验证登录
   */
  verifyLogin() {
    if (user.userLogin() == false) {
      router.push('login');
      return true;
    }
    return false;
  },
  /**
   * 显示消息提示框
   *
   * @param message 文本内容
   * @param url 跳转链接
   * @param params 参数
   * @param duration 提示的延迟时间，单位毫秒，默认：1500
   */
  alert(message = '', url = '', params = {}, duration = 1500) {
    uaService.type().then(res => {
      const type = res
      if (type == 'mobile') {
        Toast({
          message,
          position: 'middle',
          duration: 1000
        });
      } else {
        const options = {
          message: message,
          duration: 1000,
          center: true,
          iconClass: ''
        };
        Message(options);
      }
    })
    if (url == '') return;
    setTimeout(() => {
      if (url == 'back') { //返回
        router.pop();
      } else { //跳转
        router.push(url, params);
      }
    }, duration);
  },

  /**
   * 显示加载框
   *
   * @param message 文本内容
   */
  loading(message = '加载中...') {
    uaService.type().then(res => {
      const type = res
      if (type == 'mobile') {
        Indicator.open({
          text: message,
          spinnerType: 'fading-circle'
        });
      } else {
        const options = {
          text: message,
        };
        loadingInstance = Loading.service(options);
      }
    })
  },

  /**
   * 隐藏加载框
   */
  hideLoading() {
    uaService.type().then(res => {
      const type = res
      if (type == 'mobile') {
        Indicator.close();
      } else {
        if (loadingInstance) loadingInstance.close();
      }
    })

  }
}



// WEBPACK FOOTER //
// ./src/assets/plugin/prototypes/modules/hud.js